var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Button.module.css';
import { classNames } from '../../utils';
import Loader from '../Loader';
const LoaderSize = {
    small: '0.625rem',
    medium: '0.75rem',
    large: '1.125rem',
};
const Button = (_a) => {
    var { className, children, size = 'medium', variant = 'solid', fullWidth, roundedCorners, isLoading } = _a, props = __rest(_a, ["className", "children", "size", "variant", "fullWidth", "roundedCorners", "isLoading"]);
    return (_jsxs("button", Object.assign({ className: classNames(styles.button, styles[size], styles[variant], fullWidth ? styles.fullWidth : null, roundedCorners ? styles.roundedCorners : null, className) }, props, { children: [!isLoading && children, isLoading && (_jsx(Loader, { size: LoaderSize[size], className: props.disabled ? styles.loaderDisabled : styles.loaderDefault }, void 0))] }), void 0));
};
export default Button;
